import * as React from 'react';
import { Lock } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Field } from 'formik';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultipleSelectChip = ({ entries, readOnly, customChange, customValue, refresh, ...props }) => {
  const theme = useTheme();
  const [singleEntry, setSingleEntry] = React.useState(customValue ? (customValue?.length > 0 ? customValue : []) : []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSingleEntry(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );

    return(singleEntry);
  };

  const checkingArrayValues = (arr1, arr2) => {
    return arr1.filter((entry) => arr2.indexOf(entry) > -1);
  };

  const getStyles = (entries, singleEntry, theme) => {
    return {
      fontWeight:
        singleEntry.indexOf(entries) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    };
  };

  return (
    <Field id={props.id} name={props.id} label={props.label}>
      {({ field, form }) => (
        <div className='w-100'>
          {/* { props.label && <label className="label">{props.label} {props.required && '*'} { readOnly && <Lock fontSize="10px" style={{ marginBottom: '-2px' }} />}</label> } */}
          <FormControl sx={{ width: "100%" }}>
            <InputLabel id="multiple-chip-label">{`${props.label}`}</InputLabel>
            <Select
              labelId="multiple-chip-label"
              id={props.id}
              multiple
              value={singleEntry}
              onChange={( e ) => {
                const { target: { value }, } = e;
                setSingleEntry(typeof(value) === 'string' ? value.split(',') : value)
                
                form.setFieldValue( field.name,  singleEntry);
                               
                if(customChange) customChange(field.name, value ? value : [])
              }}
              input={<OutlinedInput id="multiple-chip" label={props.label} />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {entries.map((entry) => (
                <MenuItem
                  key={entry}
                  value={entry}
                  style={getStyles(entry, singleEntry, theme)}
                >
                  {entry}
                  
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
    </Field>
    
  );
};

export default MultipleSelectChip;